import CookieNotice from '@mirzalikic/react-cookie-notice';
// import '@babel/polyfill';
import React, { useEffect, Suspense, useState } from 'react';
import { Provider } from "mobx-react";
import Root from './Components/Root';
import * as store from "./Stores";
import { AsyncTrunk } from 'mobx-sync';
import 'react-bootstrap';
import './App.css';
import './utils/axiosInterceptor';
import { useTranslation } from 'react-i18next';
//import { isMobile } from 'react-device-detect';
//import packageJson from "../package.json";
//import { getBuildDate } from "./utils/utils";
//import withClearCache from './ClearCache';
//import ReactPixel from 'react-facebook-pixel';

const trunk = new AsyncTrunk(store, { storage: localStorage });

trunk.init().then(() => {
    store.myShopApiStore.setInit();
    store.helperStore.setInit();
    store.storageMngr.setInit();
    store.ifaceMngr.setInit();
});

function CookieNoticeWrapper() {
    const { t, i18n, ready } = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n.language);
    const cookiePrefix = "my-cookie-consent-site";
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // בדיקה אם המשתמש כבר שמר העדפות
        const savedPreferences = localStorage.getItem(`${cookiePrefix}-saved`);
        if (savedPreferences === 'true') {
            setIsVisible(false);
        }
    }, [cookiePrefix]);

    useEffect(() => {
        const handleLanguageChanged = (lng) => {
            setCurrentLang(lng);
        };
        i18n.on('languageChanged', handleLanguageChanged);
        return () => {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, [i18n]);

    if (!ready || !isVisible) {
        return null;
    }

    return (
        <CookieNotice
            key={currentLang}
            acceptAllButtonText={t('Accept all cookies')}
            preferencesButtonText={t('Decline all')}
            savePreferencesButtonText={t('Confirm decline all')}
            showCookiePreferences={true}
            toggleVisibility={showCookieNotice}
            onSave={async (cookies) => {
                 // שמירת העדפה גם כאשר כל העוגיות נדחו
                 localStorage.setItem(`${cookiePrefix}-saved`, 'true');
                 setIsVisible(false);
                 await store.ifaceMngr.updatePixelsConsent(cookies, cookiePrefix)();
            }}
            cookiePrefix={cookiePrefix}
            cookies={[
                ...(process.env.REACT_APP_FACEBOOK_PIXEL ? [
                    { 
                        name: 'facebook-pixel', 
                        checked: false, 
                        editable: true, 
                        default: true,
                        title: t('Facebook Pixel'), 
                        text: t('Facebook Pixel allows us to track user activity on the site and improve the browsing experience and service.')
                    }
                ] : []),
                ...(process.env.REACT_APP_TIKTOK_PIXEL ? [
                    { 
                        name: 'tiktok-pixel', 
                        checked: false, 
                        editable: true, 
                        default: true,
                        title: t('TikTok Pixel'), 
                        text: t('The TikTok pixel allows us to track user activity on the site and improve the browsing experience and service.') 
                    }
                ] : []),
                ...(process.env.REACT_APP_GOOGLE_TM ? [
                    { 
                        name: 'google-tag-manager', 
                        checked: false, 
                        editable: true, 
                        default: true,
                        title: t('Google Tag Manager'), 
                        text: t('Google Tag Manager allows us to track user activity on the site and improve the browsing experience and service.')
                    }
                ] : [])
            ]}
            containerClass="react-cookie-notice-container"
        >
            <h3>{t('This website uses cookies')}</h3>
            <p>
                {t('We use cookies that help the website to function and also to track how you interact with it. We will only use the cookies if you consent to it by clicking on \"Accept all cookies\". You can also decline all.')}
                <button 
                    style={{ marginLeft: '5px', marginRight: '5px', textDecoration: 'underline', background: 'none', border: 'none', padding: 0, font: 'inherit', color: '#5fdafb', cursor: 'pointer' }} 
                    onClick={() => {
                        const preferencesButton = document.querySelector('.react-cookie-notice-button-secondary');
                        if (preferencesButton) {
                            preferencesButton.click();
                        }
                    }}
                >
                    {t('Cookies List')}
                </button>
            </p>
        </CookieNotice>
    );
}

const showCookieNotice = process.env.REACT_APP_FACEBOOK_PIXEL || process.env.REACT_APP_TIKTOK_PIXEL || process.env.REACT_APP_GOOGLE_TM;

function App(props) {

    useEffect(() => {
        window.process = {
            ...window.process,
        };
        store.ifaceMngr.allPixelsInit("my-cookie-consent-site");

    }, []);
    
    return (
        <>
            {showCookieNotice  && (
                <Suspense fallback={<div>Loading...</div>}>
                    <CookieNoticeWrapper />
                </Suspense>
            )}
            <Provider {...store}>
                <Root/>
            </Provider>
        </>
    );
}

export default App;
